module.exports = __webpack_public_path__ + "images/emoji/bomb.b10ce4d8db85545712f1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bomb.png
// module id = xGJ7
// module chunks = 14